import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createAgent } from "../../api/apiAgents";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateAgent = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createAgentAction, isPending } = useMutation({
        mutationFn: createAgent,
        onSuccess: (res) => {
            const message = res?.message || "Agent created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["agents"] });
            navigate("/agents");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create agent");
        },
    });

    return { createAgent: createAgentAction, isPending };
};

export default useCreateAgent;
